import React from 'react';

import { Account, LifecycleStatus } from '@ndvr/portfolio-api';

import { titleCase } from 'utils';
import { LinkAccountDrawer } from 'views/household/AccountGroupTab/LinkAccountDrawer';

interface LinkAccountProps {
    account: Account;
}

export const canLinkAccount = (account: Account) =>
    !account.custodyAccountId &&
    !account.externallyManaged &&
    !account.originAccountGUID &&
    account.lifecycleStatus === LifecycleStatus.DRAFT;

export const LinkAccount = ({ account }: LinkAccountProps) => {
    const [isOpen, setIsOpen] = React.useState(false);

    if (account.custodyAccountId) {
        return (
            <div className="text-sm">
                <div className="flex flex-col">
                    <div>{account.custodyAccountId}</div>
                    <span className="text-xs text-gray-500">{titleCase(account.custodyType)}</span>
                </div>
            </div>
        );
    }

    if (account.externallyManaged) {
        return <div>Held Away</div>;
    }

    if (canLinkAccount(account)) {
        return (
            <>
                <a className="cursor-pointer text-blue-600 hover:underline" onClick={() => setIsOpen(true)}>
                    Link Account
                </a>
                {isOpen && <LinkAccountDrawer onClose={() => setIsOpen(false)} account={account} />}
            </>
        );
    }
    return <div className="text-sm text-gray-500">Unlinked</div>;
};
